// extracted by mini-css-extract-plugin
module.exports = {"root":"DragIcon_root__18c8h"};